import { Modal } from "antd";
import styled from "styled-components";

export const ModalStyled = styled(Modal)`
    .ant-modal-content {
        padding: 72px 36px 36px;
    }

    .ant-modal-body {
        position: relative;
        display: flex;
        gap: 32px;
        min-height: 436px;
    }
`;
